module.exports = __webpack_public_path__ + "resources/img/solution_game_kr.31bf0d3113991a82cef50bfe1a3192a7.jpg";